import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

// Used for admin scoped tooling
export const marketingToolingAdminAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.MarketingToolingAdminAccess],
  featureToggles: [FeatureToggle.marketingToolingEnabled],
}
